import { render } from "./DemoAdvertisingMaterial.vue?vue&type=template&id=7cd7b617&scoped=true"
import script from "./DemoAdvertisingMaterial.vue?vue&type=script&lang=js"
export * from "./DemoAdvertisingMaterial.vue?vue&type=script&lang=js"

import "./DemoAdvertisingMaterial.vue?vue&type=style&index=0&id=7cd7b617&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd7b617"]])

export default __exports__